
import Form from '@/shared/mixins/Form';
import { defineComponent } from 'vue';
import { required, email } from '@vuelidate/validators';
import { accountService } from './AccountService';
import useVuelidate from '@vuelidate/core';

export default defineComponent({
  name: 'ForgotPassword',
  mixins: [Form],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      form: {
        email: null,
      },
    };
  },
  validations() {
    return {
      form: {
        email: { required, email },
      },
    };
  },
  methods: {
    async send() {
      if (!this.validate()) return;

      try {
        await accountService.forgotPassword(this.form);
        this.success();
      } catch (error) {
        this.handleApiError(error);
      }
    },
  },
});
